<template>
  <div>
    <a-card size="small">
      <a-form-model layout="inline">
        <a-form-model-item label="时间范围">
          <a-range-picker v-model="timeList" :show-time="{ format: 'HH:mm' }" format="YYYY-MM-DD HH:mm" @change="onChange" />
        </a-form-model-item>
        <a-form-model-item label="环境">
          <a-radio-group v-model="filterForm.env" button-style="solid" @change="onChange">
            <a-radio-button value="prod"> 生产环境 </a-radio-button>
            <a-radio-button value="qa"> QA环境 </a-radio-button>
            <a-radio-button value="dev"> DEV环境 </a-radio-button>
          </a-radio-group>
        </a-form-model-item>
      </a-form-model>
    </a-card>
    <a-card size="small" style="margin-top: 16px">
      <a-table :pagination="pagination" :loading="loading" size="middle" :width="700" row-key="service_name" :columns="columns" :data-source="dataSource" @change="handleTableChange" />
    </a-card>
  </div>
</template>

<script>
import moment from 'moment';
import { apmQuery } from '@/api/data/monitor';

const columns = [
  {
    title: '服务名称',
    dataIndex: 'service_name',
    width: 200,
    ellipsis: true,
    key: 'service_name',
    scopedSlots: { customRender: 'serviceName' }
  },
  {
    width: 120,
    align: 'center',
    key: 'service_cpm',
    dataIndex: 'service_cpm',
    title: '平均负载(calls/main)'
  },
  {
    width: 100,
    align: 'center',
    key: 'service_sla',
    title: '成功率(%)',
    dataIndex: 'service_sla',
    customRender: (_value, _row) => {
      return `${parseFloat((_row.service_sla / 100).toFixed(2))}%`;
    }
  },
  {
    width: 100,
    align: 'center',
    title: 'P90(ms)',
    customRender: (_value, _row) => {
      return _row.service_percentile.P90;
    }
  },
  {
    width: 100,
    align: 'center',
    title: 'P95(ms)',
    customRender: (_value, _row) => {
      return _row.service_percentile.P95;
    }
  },
  {
    width: 100,
    align: 'center',
    title: 'P95(ms)',
    customRender: (_value, _row) => {
      return _row.service_percentile.P99;
    }
  },
  {
    width: 100,
    align: 'center',
    title: '平均响应时间(ms)',
    key: 'service_resp_time',
    dataIndex: 'service_resp_time'
  },
  {
    width: 100,
    align: 'center',
    key: 'service_apdex',
    title: '性能指数',
    dataIndex: 'service_apdex',
    customRender: (_value, _row) => {
      return (_row.service_apdex / 10000).toFixed(2);
    }
  }
];

export default {
  data() {
    return {
      columns,
      loading: false,
      dataSource: [],
      filterForm: {
        env: 'prod'
      },
      pagination: {
        size: 'large',
        total: 0,
        pageSize: 10, // 每页中显示10条数据
        showSizeChanger: true,
        pageSizeOptions: ['10', '20'], // 每页中显示的数据
        showTotal: total => `共 ${total} 条` // 分页中显示总的数据
      },
      timeList: [moment().subtract(30, 'minutes'), moment()]
    };
  },
  mounted() {
    this.onChange();
  },
  methods: {
    onChange() {
      if (this.timeList.length > 0) {
        this.filterForm.begin_time = moment(this.timeList[0]).format('YYYY-MM-DD HH:mm:ss');
        this.filterForm.end_time = moment(this.timeList[1]).format('YYYY-MM-DD HH:mm:ss');
      } else {
        this.filterForm.begin_time = null;
        this.filterForm.end_time = null;
      }
      this.pagination.current = 1;
      this.getAPMData();
    },
    handleTableChange(pagination) {
      if (pagination.pageSize !== this.pagination.pageSize) {
        pagination.current = 1;
      }
      this.pagination = pagination;
      this.getAPMData();
    },
    getAPMData() {
      this.loading = true;
      apmQuery({ ...this.filterForm, page_size: this.pagination.pageSize, page_number: this.pagination.current })
        .then(res => {
          this.dataSource = res.data.items;
          this.pagination.total = res.data.total;
          this.loading = false;
        })
        .catch(res => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="less" scoped>
.ant-form-item {
  margin-bottom: 0;
}
</style>
